/**
 * @file platform-env.ts
 * @description Адреса платформы для экранов «Магазины» и «Домены» (phase19.28
 * этап А): базовый домен поддоменов магазинов и внешний IP сервера для
 * DNS-записей своего домена (devops-domains-routing §1.2, §3.1).
 *
 * Значения — из переменных сборки (`VITE_PLATFORM_BASE_DOMAIN`,
 * `VITE_PLATFORM_PUBLIC_IP`); в коде — только запасные значения на случай,
 * если сборка их не передала. IP провайдер уже менял — в инструкции он
 * подписан «проверьте перед вводом».
 */

/** Базовый домен поддоменов магазинов: `<slug>.commora.ru`. */
export const PLATFORM_BASE_DOMAIN: string = import.meta.env.VITE_PLATFORM_BASE_DOMAIN || "commora.ru";

/** Внешний IP сервера платформы — значение A-записей своего домена магазина. */
export const PLATFORM_PUBLIC_IP: string = import.meta.env.VITE_PLATFORM_PUBLIC_IP || "188.134.79.241";

/** Памятка владельцу платформы по хосту в NPM (devops §3.2). */
export const NPM_GUIDE_DOC = "docs/processes/npm-shop-domain.md";
